// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"223":"216d5d719505d9ead79f","245":"6479334812f266b35af8","453":"5b85c522b50bf24241e8"}[chunkId] + ".js";
};